import { Checklist } from '../generated-types/checklist-types'

export interface InteractiveSchema {
    id: number;
    customerId: number;
    name: string;
    description?: string;
    supportedEquipmentTypeIds: number[];
    preferredEquipmentTypeId?: number;
    hasWashingSection: boolean;
    hasMeshBreakageSection: boolean;
    hasDivingCertificationSection: boolean;
    hasAttachmentsSection: boolean;
    checklistId?: number;
    checklist?: Checklist;
    isChecklistMandatory: boolean;
    procedureFileId?: number;
    configuration?: InteractiveSchemaConfig;
    isActive: boolean;
    createdAt: string;
}

export interface InteractiveSchemaConfig {
    washing?: WashingSectionConfig;
    meshBreakage?: MeshBreakageSectionConfig;
    documents?: DocumentLink[];
    notes?: string;
}

export interface WashingSectionConfig {
    mandatory: boolean;
    order: number;
    fields?: Record<string, FieldConfig>;
}

export interface MeshBreakageSectionConfig {
    mandatory: boolean;
    order: number;
}

export interface FieldConfig {
    required: boolean;
    type: string;
    label?: string;
    options?: string[];
}

export interface DocumentLink {
    type: string;
    fileId?: number;
    url?: string;
    title: string;
}


export interface InteractiveSchemaReport {
    id: number;
    interactiveSchemaId: number;
    schema?: InteractiveSchema;
    reportName: string;
    startDate: string;
    completedDate?: string;
    responsibleUserId: string;
    responsibleUser?: any;
    vesselId?: string;
    vesselName?: string;
    equipmentIds: number[];
    attachmentFileIds: number[];
    status: ReportStatus;
    reportData: ReportData;
    formSchemaReportId?: number;
    findings: InteractiveSchemaReportFinding[];
    createdAt: string;
}

export enum ReportStatus {
    Draft = 0,
    InProgress = 1,
    Completed = 2,
    Approved = 3,
}

export interface ReportData {
    general?: {
        interactiveSchemaId: number;
        reportName: string;
        startDate: string;
        responsibleUserId: string;
        vesselName?: string;
    };
    washing?: WashingSectionData;
    meshBreakage?: MeshBreakageSectionData;
    divingCertification?: DivingCertificationSectionData;
    checklist?: ChecklistSectionData;
    notes?: string;
}

export interface WashingSectionData {
    isCompleted: boolean;
    completedAt?: string;
    completedByUserId?: string;
    fieldValues?: Record<string, any>;
}

export interface MeshBreakageSectionData {
    isCompleted: boolean;
    completedAt?: string;
    completedByUserId?: string;
    hasBreakage: boolean;
    findingsCount: number;
}

export interface DivingCertificationSectionData {
    isCompleted: boolean;
    completedAt?: string;
    completedByUserId?: string;
    certifications?: DivingCertificationEntry[];
}

export interface DiverDto {
    id: number;
    name: string;
    certificateNumber?: string;
    healthCertificateValidUntil?: string;
}

export interface CreateDiverDto {
    name: string;
    certificateNumber?: string;
    healthCertificateValidUntil?: string;
}

export interface UpdateDiverDto {
    name: string;
    certificateNumber?: string;
    healthCertificateValidUntil?: string;
}

export interface DivingCertificationEntry {
    role?: 'standby' | 'diveLead' | 'other'
    diverId?: number
    diverName: string
    certificateNumber?: string
    healthCertificateValidUntil?: string
    comment?: string
    timeInSea?: string
    timeLeavingSurface?: string
    timeOnBottom?: string
    timeLeavingBottom?: string
    timeOnSurface?: string
    maxDepth?: number
    decompressionInSea?: boolean
    diveNumber?: number
    repeatedDive?: boolean
    nitrogenAfterDive?: string
}

export interface ChecklistSectionData {
    isCompleted: boolean;
    answers?: Record<number, any>;
}


export interface InteractiveSchemaReportFinding {
    id?: number;
    interactiveSchemaReportId?: number;
    mainComponentId?: number;
    mainComponent?: any;
    postNumber: string;
    size: string;
    depth?: number;
    discoveryTime: string;
    comment?: string;
    imageIds: number[];
    createdAt?: string;
}

export interface CreateInteractiveSchemaReportDto {
    interactiveSchemaId: number;
    reportName: string;
    startDate: string;
    vesselId?: string;
    vesselName?: string;
    mainComponentId: number;
}

export interface UpdateInteractiveSchemaReportDto {
    reportName: string;
    vesselId?: string;
    vesselName?: string;
    equipmentIds: number[];
}

export interface CreateFindingDto {
    mainComponentId?: number;
    postNumber: string;
    size: string;
    depth?: number;
    discoveryTime: string;
    comment?: string;
    imageIds: number[];
}

export interface UpdateFindingDto {
    mainComponentId?: number;
    postNumber: string;
    size: string;
    depth?: number;
    discoveryTime: string;
    comment?: string;
    imageIds: number[];
}